module.exports = __webpack_public_path__ + "img/popupAd-day5.312f09a6.png";